import React from "react"
import CookieConsent from "react-cookie-consent"
import { initializeAndTrack } from "gatsby-plugin-gdpr-cookies"
import * as styles from "./CookieConsent.module.css"

const CookieBanner = () => {
  const handleAccept = () => {
    initializeAndTrack(window.location)
  }

  const handleDecline = () => {
    // User declined, don't initialize tracking
    console.log("User declined cookies")
  }

  return (
    <CookieConsent
      location="bottom"
      buttonText="Accept"
      declineButtonText="Decline"
      cookieName="gatsby-gdpr-google-analytics"
      style={{
        background: "#2B373B",
        fontSize: "14px",
        padding: "20px",
        alignItems: "center",
      }}
      buttonStyle={{
        color: "#ffffff",
        backgroundColor: "#1976d2",
        fontSize: "14px",
        padding: "10px 20px",
        borderRadius: "4px",
        border: "none",
        cursor: "pointer",
        marginLeft: "10px",
      }}
      declineButtonStyle={{
        color: "#ffffff",
        backgroundColor: "#666",
        fontSize: "14px",
        padding: "10px 20px",
        borderRadius: "4px",
        border: "none",
        cursor: "pointer",
        marginLeft: "10px",
      }}
      expires={150}
      enableDeclineButton
      onAccept={handleAccept}
      onDecline={handleDecline}
      containerClasses={styles.cookieContainer}
      contentClasses={styles.cookieContent}
      buttonWrapperClasses={styles.cookieButtons}
    >
      <div className={styles.cookieText}>
        <strong>We use cookies</strong>
        <p>
          This site uses cookies to improve your experience and analyze site traffic. 
          By continuing to use this site, you agree to our use of cookies.
        </p>
      </div>
    </CookieConsent>
  )
}

export default CookieBanner